import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { AppDispatch, Store } from '../Store/StoreInit';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { fetchUsersList, setUserDetails } from '../Store/UserDetailsReducer';
import { fetchFacilityDetailList } from '../Store/RRDInventoryReducer';

const AppInit = () => {
  const { instance, inProgress, accounts } = useMsal();
  const [appInitialised, setAppInitialised] = useState<boolean>(false);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() =>{
    dispatch(fetchUsersList());
    dispatch(fetchFacilityDetailList());
  },[])

  useEffect(() => {
    if (inProgress === InteractionStatus.None && accounts.length > 0) {
      const account = accounts[0];

      if (!appInitialised) {
        InitAppData(account.username);
      }
    }
  });

  const InitAppData = async (useremail: string) => {
    const baseurl = process.env.REACT_APP_RRD_OPTIMIZATION_BASE_URL as string;
  
    try {
      const response = await axios.get(`${baseurl}/User/Users/${useremail}`, {
        headers: {
          Pragma: 'no-cache',
        },
      });
  
      if (response.data?.result) {
        dispatch(setUserDetails.setUserDetails(response.data.result));
        localStorage.setItem('userdetails', JSON.stringify(response.data.result));
      } else {
        console.error('No user details found in the response.');
      }
  
      setAppInitialised(true);
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };

  return <></>;
};

export default AppInit;
